import { render, staticRenderFns } from "./LotName.vue?vue&type=template&id=821696ac&"
import script from "./LotName.vue?vue&type=script&lang=js&"
export * from "./LotName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports